import { zRequiredString } from "@goodfill/domain-properties-zod-validators";
import { hasOnlyAsciiChars } from "@goodfill/string";
import { atom } from "recoil";
import z from "zod";
import { zRequiredPhone } from "../../../../../../form/zod/formPhone";
import { zRequiredEmail } from "../../../../../../form/zod/zodTypes";

export const validStep1State = atom<ValidStep1SignUpState | null>({
  key: "customer-application-step1",
  default: null,
});

export const step1SignUpState = z.object({
  firstName: zRequiredString()
    .max(18, { message: "max characters 18" })
    .refine(hasOnlyAsciiChars, { message: "only English chars" }),
  lastName: zRequiredString()
    .max(50, { message: "max characters 50" })
    .refine(hasOnlyAsciiChars, { message: "only English chars" }),
  phone1: zRequiredPhone,
  email: zRequiredEmail,
});

export type ValidStep1SignUpState = z.infer<typeof step1SignUpState>;
